
//listen for any click events on the body tag
document.querySelector('body').addEventListener('click', (event) => {

    //ignore any click events that's are not to an external site
    if (event.target.matches('a[href^="http"]:not([href^="https://www.nrla.org.uk"])')) {
        navigator.sendBeacon(`/r/${encodeURIComponent(event.target.getAttribute('href'))}?beacon=yes`);
    }

});
